<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;
}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/purchase/requisition/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('caigoushenqinghao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select multiple :max="99" type="PURCHASE_REQ_STATUS" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wuliao')">
            <yi_data_select type="material2" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenqingbumen')">
            <yi_data_select type="organization" :ids.sync="yt.conditions.reqOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jianyicaigouriqi')">
            <yi_time_input type="daterange" :format="'yyyy-MM-dd'" :start.sync="yt.conditions.reqPurchaseDateStart" :end.sync="yt.conditions.reqPurchaseDateEnd"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_purchasing_management_purchase_requisition_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowInsertDialog)">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status === '0' && scope.row.createBy === loginUserId">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1', beforeShowEditDialog)" v-if="utils.checkPower('web_purchasing_management_purchase_requisition_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status === '0' || scope.row.status === '1'">
            <el-button type="text" @click="yt.showEditDialog('chuangjiancaigoudingdan', scope.row, '80%', beforeShowCreatePurchaseOrderDialog)" v-if="utils.checkPower('web_purchasing_management_purchase_requisition_createPurchaseOrderWithDetail')">{{ $t('chuangjiancaigoudingdan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.closeLoading" @click="closeRequisition(scope.row)" v-if="utils.checkPower('web_purchasing_management_purchase_requisition_close')">{{ $t('guanbi') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status === '0' && scope.row.createBy === loginUserId">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/purchase/requisition/delete')" v-if="utils.checkPower('web_purchasing_management_purchase_requisition_delete')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '采购申请-删除' } }">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action === 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shenqingbumen')" required>
            <yi_data_select type="organization" :ids.sync="yt.editObj.reqOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenqingren')">
            <yi_data_select ref="employee" type="employee" :ids.sync="yt.editObj.reqUserId" @change="employeeChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenqingleixing')" required>
            <yi_dictionary_select type="PURCHASE_REQ_TYPE" :ids.sync="yt.editObj.reqType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wuliao')" required>
            <yi_data_select type="material2" :ids.sync="yt.editObj.materialId" @change="materialChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('caigoushuliang')" required>
            <el-input-number size="mini" v-model="yt.editObj.purchaseQuantity" :min="0" :precision="4"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('caigoudanwei')" required>
            <yi_dictionary_select type="UNIT_CONVERSION_TYPE" :ids.sync="yt.editObj.unit"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyicaigouriqi')">
            <yi_time_input type="date" :format="'yyyy-MM-dd'" :time.sync="yt.editObj.reqPurchaseDate" :minTime="0" :maxTime="yt.editObj.maxTime" :minMaxBase="'current'"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jianyigongyingshang')">
            <yi_data_select type="supplier" :ids.sync="yt.editObj.reqSupplierId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input :maxlength="400" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/purchase/requisition/create')" :loading="yt.editObj.loading" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '采购申请-新增' } }">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action === 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shenqingbumen')" required>
            <yi_data_select type="organization" :ids.sync="yt.editObj.reqOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenqingren')">
            <yi_data_select type="employee" :ids.sync="yt.editObj.reqUserId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenqingleixing')" required>
            <yi_dictionary_select type="PURCHASE_REQ_TYPE" :ids.sync="yt.editObj.reqType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('wuliao')" required>
            <yi_data_select type="material2" :ids.sync="yt.editObj.materialId" @change="materialChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('caigoushuliang')" required>
            <el-input-number size="mini" v-model="yt.editObj.purchaseQuantity" :min="0" :precision="4"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('caigoudanwei')" required>
            <yi_dictionary_select type="UNIT_CONVERSION_TYPE" :ids.sync="yt.editObj.unit"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyicaigouriqi')">
            <yi_time_input type="date" :format="'yyyy-MM-dd'" :time.sync="yt.editObj.reqPurchaseDate" :minTime="0" :maxTime="yt.editObj.maxTime" :minMaxBase="'current'"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jianyigongyingshang')">
            <yi_data_select type="supplier" :ids.sync="yt.editObj.reqSupplierId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input :maxlength="400" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/purchase/requisition/update')" :loading="yt.editObj.loading" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '采购申请-编辑' } }">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'chuangjiancaigoudingdan'">
        {{
          $nextTick(() => {
            $refs.yt2.list = addList;
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{ $t('caigoudingdantouxinxi') }}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <el-form-item :label="$t('gongyingshangmingcheng')" required>
                <yi_data_select type="supplier" :ids.sync="yt.editObj.supplierId" @change="getItemSupplier"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required>
                <el-input v-model="yt.editObj.supplierAddress"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required>
                <el-input v-model="yt.editObj.address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuofang')" required>
                <yi_data_select type="organization" :ids.sync="yt.editObj.orgId"> </yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('caigouyuan')" required>
                <yi_data_select type="customer_user" :queryFilter="e => e.enabled == true" :ids.sync="yt.editObj.purchaser"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('caigoudingdanmingxixinxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <template #buttonsL="scope">
                <el-button size="mini" @click="addTable(scope._index, $event)" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
              </template>
              <template #caigoudingdanhanghao="scope">
                <el-input class="inputClass" v-model="scope.row.no" :disabled="true"></el-input>
              </template>
              <template #mingxizhuangtai="scope">
                <el-tag size="small" :value="scope.row.status">{{ $t('xinjian') }}</el-tag>
              </template>
              <template #wuliaobianmamingcheng="scope">
                <yi_data_select class="inputClass" type="material2" :ids.sync="scope.row.materialId" disabled> </yi_data_select>
              </template>
              <template #dingdanshuliang="scope">
                <el-input class="inputClass" v-model="scope.row.quantity" :disabled="!scope.row.edit"></el-input>
              </template>
              <template #caigoudanwei="scope">
                <el-input class="inputClass" v-model="scope.row.unit" disabled></el-input>
              </template>
              <template #caigoushenqinghao="scope">
                <yi_cross_select :ref="'purchase_requisition' + scope._index" :key="scope._index" class="inputClass" :max="1" :selectTitle="'no'" :disabled="scope.row.first" :component="'web_purchasing_management_purchase_requisition_list'" :ids.sync="scope.row.purchaseRequisitionId" @getItems="getItemsPurchaseRequisition(scope._index, $event)" :fixConditions="{ statusList: ['0', '1'] }"> </yi_cross_select>
              </template>
              <template #dingdanjiaoqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.deliveryTime" :disabled="!scope.row.edit"> </yi_time_input>
              </template>
              <template #chaoliangjieshouyuncha="scope">
                <el-input-number disabled class="inputClass" :precision="2" :min="0" v-model="scope.row.tolerance" :controls="false"></el-input-number>
              </template>
              <template #beizhu="scope">
                <el-input class="inputClass" v-model="scope.row.remark"></el-input>
              </template>
              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="remove(scope._index, $event)" :disabled="scope.row.first">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/purchase/requisition/createPurchaseOrderWithDetail', beforeAdd, afterAddOrUpdate)" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '采购申请-创建采购订单保存' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Bury from '@/common/bury.js';

export default {
  name: 'web_purchasing_management_purchase_requisition_list',
  components: {},
  data() {
    return {
      loginUserId: null,
      addList: [],
      columns: [
        {
          label: 'caigoushenqinghao',
          prop: 'no',
          width: 150
        },
        {
          label: 'shenqingleixing',
          prop: 'reqType',
          type: 'dictionary',
          key: 'PURCHASE_REQ_TYPE'
        },
        {
          label: 'shenqingriqi',
          prop: 'reqDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 180
        },
        {
          label: 'shenqingbumen',
          prop: 'reqOrg.name'
        },
        {
          label: 'shenqingren',
          prop: 'reqUser.name'
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'PURCHASE_REQ_STATUS'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'guige',
          prop: 'material.spec'
        },
        {
          label: 'caigoudanwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'caigoushuliang',
          prop: 'purchaseQuantity'
        },
        {
          label: 'shengyucaigoushuliang',
          prop: 'leftQuantity',
          width: 130
        },
        {
          label: 'jianyicaigouriqi',
          prop: 'reqPurchaseDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 180
        },
        {
          label: 'laiyuandanhao',
          prop: 'srcDocNo'
        },
        {
          label: 'jianyigongyingshang',
          prop: 'reqSupplier.name',
          width: 130
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ],
      columnsItem: [
        {
          label: 'caigoudingdanhanghao',
          prop: 'no',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'slot',
          wrap: true,
          width: 80
        },
        {
          label: 'wuliaobianmamingcheng',
          prop: 'materialId',
          type: 'slot',
          wrap: true,
          width: 180
        },
        {
          label: 'dingdanshuliang',
          prop: 'quantity',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'caigoudanwei',
          prop: 'defaultUnit',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'caigoushenqinghao',
          prop: 'purchaseRequisitionNo',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'dingdanjiaoqi',
          prop: 'deliveryTime',
          width: 150,
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'chaoliangjieshouyuncha',
          prop: 'tolerance',
          type: 'slot',
          wrap: true,
          width: 160
        },
        {
          label: 'beizhu',
          prop: 'remark',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          wrap: true,
          fixed: 'right'
        }
      ]
    };
  },
  destroyed() {},
  watch: {
    'yt.isShowEditDialog': {
      handler(n) {
        if (this.yt.editObj.action === 'chuangjiancaigoudingdan' && n == false) {
          this.addList = [];
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    this.loginUserId = this.$store.state.user.id;
    setTimeout(() => {
      this.yt.get(1);

      this.yt.SELECT_URL = '/web/purchase/requisition/extend/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
    }, 300);
  },
  methods: {
    employeeChange(id, item) {
      if (id == null) {
        const items = this.$refs['employee'].items || [];
        const ids = items.filter(item => item.userId === this.loginUserId);
        if (ids.length > 0) {
          this.yt.editObj.reqUserId = ids[0].id;
        }
      }
    },
    getItemsPurchaseRequisition(index, item) {
      if (item) {
        const id = item.id;
        const uniIds = this.addList.map(item => item.uniId);
        if (uniIds.indexOf(id) !== -1) {
          this.$message.warning(this.$t('yicunzaimingxizhong'));
          this.$refs['purchase_requisition' + index].setIds(null);
          return;
        }
        this.$set(this.$refs.yt2.list[index], 'edit', true);
        this.$set(this.$refs.yt2.list[index], 'materialId', item.materialId);
        this.$set(this.$refs.yt2.list[index], 'quantity', item.leftQuantity || 0);
        this.$set(this.$refs.yt2.list[index], 'unit', item.unit || '');
        this.$set(this.$refs.yt2.list[index], 'uniId', id);
        this.$set(this.$refs.yt2.list[index], 'purchaseRequisitionNo', item.no || '');
        if (item.materialOtherInfo) {
          this.$set(this.$refs.yt2.list[index], 'tolerance', item.materialOtherInfo.exceedAcceptDiff || 0);
        }
      }
    },
    afterAddOrUpdate() {
      this.yt.isShowEditDialog = false;
      this.yt.get();
    },
    beforeAdd(params, url) {
      params.status = '0';
      params.purchaseOrderDetailList = this.$refs.yt2.list;
      return params;
    },
    remove(index, item) {
      this.addList.splice(index, 1);
      for (let i = index; i < this.addList.length; i++) {
        this.addList[i].no = this.addList[i].no - 1;
      }
    },
    addTable(item) {
      let no = null;
      if (this.addList) {
        no = this.addList.length + 1;
      } else {
        no = 1;
      }
      const newItem = {
        no: no,
        status: '0',
        materialId: '',
        quantity: '',
        unit: '',
        purchaseRequisitionId: '',
        purchaseRequisitionNo: '',
        deliveryTime: '',
        tolerance: '',
        remark: '',
        first: false
      };
      this.addList.push(newItem);
    },
    getItemSupplier(id, item) {
      if (item) {
        this.$set(this.yt.editObj, 'supplierAddress', item.address);
      } else {
        this.$set(this.yt.editObj, 'supplierAddress', null);
      }
    },
    // 在添加采购订单之前处理数据
    beforeShowCreatePurchaseOrderDialog(row) {
      row.supplierId = row.reqSupplierId;
      row.orgId = row.reqOrgId;
      row.purchaser = this.loginUserId;

      const firstItem = {
        no: 1,
        status: '0',
        materialId: row.materialId,
        quantity: row.leftQuantity,
        unit: row.unit,
        purchaseRequisitionId: row.id,
        purchaseRequisitionNo: row.no,
        deliveryTime: row.reqPurchaseDate,
        tolerance: (row.materialOtherInfo && row.materialOtherInfo.exceedAcceptDiff) || 0,
        remark: '',
        first: true,
        edit: true,
        uniId: row.id
      };
      this.addList.push(firstItem);
      return row;
    },
    // 关闭采购申请
    closeRequisition(row) {
      this.$confirm(this.$t('guanbicaigoushenqing'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          this.$set(row, 'closeLoading', true);
          Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '采购申请-关闭' } });
          this.http
            .post('/web/purchase/requisition/close', { id: row.id })
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.yt.get();
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            })
            .finally(() => {
              this.$set(row, 'closeLoading', false);
            });
        })
        .catch(() => {});
    },
    // 新增之前处理数据
    beforeShowInsertDialog(row) {
      row.reqOrgId = this.store.state.organizations[0].id;
      row.reqType = '0';
      const maxTime = 24 * 365 * 60 * 60 * 1000;
      row.maxTime = maxTime;
      return row;
    },
    // 编辑之前处理数据
    beforeShowEditDialog(row) {
      const maxTime = 24 * 365 * 60 * 60 * 1000;
      row.maxTime = maxTime;
      return row;
    },
    // 物料选择变化回调
    materialChange(id, item) {
      if (item) {
        const unit = item.defaultUnit;
        if (unit) {
          this.yt.editObj.unit = unit;
        }
      } else {
        this.yt.editObj.unit = null;
      }
    }
  }
};
</script>
